// Single source of truth for hour rounding across the time-tracking dashboard.
// All internal math stays on raw values; we round ONLY at display/export,
// always to the same precision, so the headline total, group subtotals, and
// exports reconcile instead of drifting (PT-197).

export const HOURS_DECIMALS = 1;

// Round raw hours to a Number (not string) at a fixed precision.
export const roundHours = (value, decimals = HOURS_DECIMALS) => {
  const n = Number(value) || 0;
  const factor = 10 ** decimals;
  return Math.round(n * factor) / factor;
};

// Format hours for display, always to the same precision.
export const formatHours = (value, decimals = HOURS_DECIMALS) =>
  roundHours(value, decimals).toFixed(decimals);